import {Component, Inject, Input, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {TestSuiteData} from '../testsuite.component';
import {MatDialogRef} from '@angular/material';
import {trigger, state, animate, transition, style} from '@angular/animations';

export interface TestSuiteData {
    testSuitePayload;
    testSuiteResponse;
}

declare let $;

@Component({
    selector: 'app-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({height: '0px', minHeight: '0'})),
            state('expanded', style({height: '*'})),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})
export class ReportComponent implements OnInit {


    constructor(public dialogRef: MatDialogRef<ReportComponent>,
                @Inject(MAT_DIALOG_DATA) public data: TestSuiteData) {
    }

    currentTable = 'Test Setup';
    @Input() testSuiteResponse;
    @Input() testSuitePayload = {};
    showAssertionDetails = [];
    columnsToDisplay = ['Test Case Name', 'Status', 'Assertion Status'];
    expandedElement;
    dataSource = {
        'testCaseResults': [
            {
                'apiResponse': {
                    'statusCode': 200,
                    'statusLine': 'HTTP/1.1 401 Unauthorized',
                    'body': '{"message":"No API key found in request"}',
                    'headers': [
                        {
                            'name': 'Date',
                            'value': 'Fri, 15 Jan 2021 07:37:41 GMT'
                        },
                        {
                            'name': 'Content-Type',
                            'value': 'application/json; charset=utf-8'
                        },
                        {
                            'name': 'Content-Length',
                            'value': '41'
                        },
                        {
                            'name': 'Connection',
                            'value': 'keep-alive'
                        },
                        {
                            'name': 'WWW-Authenticate',
                            'value': 'Key realm="kong"'
                        },
                        {
                            'name': 'Access-Control-Allow-Origin',
                            'value': '*'
                        },
                        {
                            'name': 'X-Kong-Response-Latency',
                            'value': '0'
                        },
                        {
                            'name': 'Server',
                            'value': 'kong/1.4.2'
                        }
                    ],
                    'cookies': {},
                    'sessionId': null,
                    'timeInMillis': 1784,
                    'contentLength': 41,
                    'attributes': [
                        {
                            'attributeName': 'message',
                            'displayName': null,
                            'description': null,
                            'type': 'String',
                            'size': 0,
                            'precision': 0,
                            'autoIncrement': false,
                            'defaultValue': null,
                            'subType': [],
                            'attributeType': null,
                            'required': false,
                            'dataStoragePolicy': null,
                            'apiAccessPolicy': null,
                            'displayPolicy': null,
                            'array': false,
                            'customType': false,
                            'updateOption': null,
                            'previousAttributeName': null
                        }
                    ]
                },
                'name': 'testCase1',
                'status': 'failure'
            }
        ],
        'preStepResults': [
            {
                'statusCode': 401,
                'statusLine': 'HTTP/1.1 401 Unauthorized',
                'body': '{"message":"No API key found in request"}',
                'headers': [
                    {
                        'name': 'Date',
                        'value': 'Fri, 15 Jan 2021 07:37:18 GMT'
                    },
                    {
                        'name': 'Content-Type',
                        'value': 'application/json; charset=utf-8'
                    },
                    {
                        'name': 'Content-Length',
                        'value': '41'
                    },
                    {
                        'name': 'Connection',
                        'value': 'keep-alive'
                    },
                    {
                        'name': 'WWW-Authenticate',
                        'value': 'Key realm="kong"'
                    },
                    {
                        'name': 'Access-Control-Allow-Origin',
                        'value': '*'
                    },
                    {
                        'name': 'X-Kong-Response-Latency',
                        'value': '1'
                    },
                    {
                        'name': 'Server',
                        'value': 'kong/1.4.2'
                    }
                ],
                'cookies': {},
                'sessionId': null,
                'timeInMillis': 5250,
                'contentLength': 41,
                'attributes': [
                    {
                        'attributeName': 'message',
                        'displayName': null,
                        'description': null,
                        'type': 'String',
                        'size': 0,
                        'precision': 0,
                        'autoIncrement': false,
                        'defaultValue': null,
                        'subType': [],
                        'attributeType': null,
                        'required': false,
                        'dataStoragePolicy': null,
                        'apiAccessPolicy': null,
                        'displayPolicy': null,
                        'array': false,
                        'customType': false,
                        'updateOption': null,
                        'previousAttributeName': null
                    }
                ]
            }
        ],
        'tearDownStepResults': [
            {
                'statusCode': 401,
                'statusLine': 'HTTP/1.1 401 Unauthorized',
                'body': '{"message":"No API key found in request"}',
                'headers': [
                    {
                        'name': 'Date',
                        'value': 'Fri, 15 Jan 2021 07:37:45 GMT'
                    },
                    {
                        'name': 'Content-Type',
                        'value': 'application/json; charset=utf-8'
                    },
                    {
                        'name': 'Content-Length',
                        'value': '41'
                    },
                    {
                        'name': 'Connection',
                        'value': 'keep-alive'
                    },
                    {
                        'name': 'WWW-Authenticate',
                        'value': 'Key realm="kong"'
                    },
                    {
                        'name': 'Access-Control-Allow-Origin',
                        'value': '*'
                    },
                    {
                        'name': 'X-Kong-Response-Latency',
                        'value': '0'
                    },
                    {
                        'name': 'Server',
                        'value': 'kong/1.4.2'
                    }
                ],
                'cookies': {},
                'sessionId': null,
                'timeInMillis': 1708,
                'contentLength': 41,
                'attributes': [
                    {
                        'attributeName': 'message',
                        'displayName': null,
                        'description': null,
                        'type': 'String',
                        'size': 0,
                        'precision': 0,
                        'autoIncrement': false,
                        'defaultValue': null,
                        'subType': [],
                        'attributeType': null,
                        'required': false,
                        'dataStoragePolicy': null,
                        'apiAccessPolicy': null,
                        'displayPolicy': null,
                        'array': false,
                        'customType': false,
                        'updateOption': null,
                        'previousAttributeName': null
                    }
                ]
            }
        ]
    };

    ngOnInit() {

    }

    getClass(val) {
        if (200 <= val && val < 300) {
            return 'success';
        } else if (300 <= val && val < 400) {
            return 'redirects';
        } else if (400 <= val && val < 500) {
            return 'dependencyError';
        } else if (val > 500) {
            return 'serverError';
        }
    }

    setCurrentTable(table) {
        this.currentTable = table;
    }

    toggleShowAssertionDetails(len, id) {
        //this.showAssertionDetails=!this.showAssertionDetails;
        if (!this.showAssertionDetails.length) {
            this.showAssertionDetails = Array(len).fill(false);
        }

        this.showAssertionDetails[id] = !this.showAssertionDetails[id];
    }

}
